import {api} from "../api/callApi";
import {urlServer} from "../api/v1";
import {IChecklist} from "../varibles/interface";

const urlBase = urlServer + "/checklist"

export const ChecklistService = {
    get: () => api.get<IChecklist[]>(urlBase),
    create: (body: IChecklist) => api.post<IChecklist>(urlBase, body),
    update: (body: IChecklist) => api.put<IChecklist>(urlBase, body),
    delete: (id: string) => api.deleteBody(urlBase, {id}),
    steps: () => api.get<{ [id: string]: string[] }>(urlBase + '/steps')
}